import { useMemo } from 'react';
import type { SpecificationViewModel } from '@api/enterprise/openapi/models/specification-view-model';
import type { BasicReadingTestPoint } from '../../../hooks/useCalibrationRuntime/types';

export const useInitializeTestPoints = (
  specs: SpecificationViewModel[],
  existingPoints: BasicReadingTestPoint[]
): BasicReadingTestPoint[] => {
  return useMemo(() => {
    if (existingPoints.length > 0) return existingPoints;

    return specs
      .filter(spec => spec.lookup !== null && spec.lookup !== undefined)
      .map(spec => ({
        id: crypto.randomUUID(),
        nominalValue: spec.lookup as number,
        tolerance: 0.1,
        asFound: null,
        asLeft: null,
        asFoundResult: null,
        asLeftResult: null
      }));
  }, [specs, existingPoints]);
};
